<template>
  <div>
    <div
      v-if="!isMobile"
      class="p-4"
    >
      <clock class="absolute clock" />
      <the-header :allowBack="false" />
      <div class="content">
        <table class="w-full table-fixed h-full">
          <tr>
            <td
              colspan="3"
              rowspan="2"
            >
              <last-24-h-chart
                :device="'I97'"
                :height="400"
              />
            </td>
            <td>

              <last-24-h-chart
                class="with-border"
                :device="'ID6'"
                :height="200"
              />

            </td>
          </tr>
          <tr>
            <td>
              <last-24-h-chart
                class="with-border"
                :device="'ID4'"
                :height="200"
              />
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <!-- <hr class="styled mb-4" /> -->
            </td>
          </tr>
          <tr>
            <td>
              <last-24-h-chart :device="'ID7'" />
            </td>
            <td>
              <last-24-h-chart :device="'ID8'" />
            </td>
            <td>
              <last-24-h-chart :device="'ID5'" />
            </td>
            <td>
              <last-24-h-chart :device="'ID3'" />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div
      v-else
      class="p-4"
    >
      <the-header :allowBack="false" />
      <clock class="clock" />
      <div class="flex-row pb-8">
        <div class="flex-col mt-4">
          <last-24-h-chart
            :device="'I97'"
            :height="240"
          />
        </div>
        <div class="flex-col mt-4">
          <last-24-h-chart
            :device="'ID3'"
            :height="240"
          />
        </div>
        <div class="flex-col mt-4">
          <last-24-h-chart
            :device="'ID4'"
            :height="240"
          />
        </div>
        <div class="flex-col mt-4">
          <last-24-h-chart
            :device="'ID5'"
            :height="240"
          />
        </div>
        <div class="flex-col mt-4">
          <last-24-h-chart
            :device="'ID6'"
            :height="240"
          />
        </div>
        <div class="flex-col mt-4">
          <last-24-h-chart
            :device="'ID7'"
            :height="240"
          />
        </div>
        <div class="flex-col mt-4">
          <last-24-h-chart
            :device="'ID8'"
            :height="240"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import TheHeader from "@app/layouts/components/TheHeader.vue";
import TheFooter from "@app/layouts/components/TheFooter.vue";
import Last24hChart from "@app/layouts/components/Last24hChart.vue";
import Clock from "@app/layouts/components/Clock.vue";
export default {
  components: {
    TheHeader,
    TheFooter,
    "last-24-h-chart": Last24hChart,
    Clock,
  },
  data() {
    return {
      isMobile: isMobile,
      devices: ["I97", "ID3", "ID4", "ID5", "ID6", "ID7", "ID8"],
    };
  },
};
</script>

<style scoped>
.clock {
  right: 20px;
}
.content {
  height: 800px;
}

.table-grid tr {
  height: 300px;
}

.table-grid td {
  padding: 0;
  height: 300px;
}

hr.styled {
  border: 0;
  height: 1px;
  background: linear-gradient(left, #6cc58c, #6b98c0, #6cc58c) !important;
  background: -webkit-linear-gradient(
    left,
    #6cc58c,
    #6b98c0,
    #6cc58c
  ) !important;
}

.with-border {
  border: 1px solid #000;
}
</style>